import { render, staticRenderFns } from "./Deliveries.vue?vue&type=template&id=2e1d3be6&scoped=true&"
import script from "./Deliveries.vue?vue&type=script&lang=ts&"
export * from "./Deliveries.vue?vue&type=script&lang=ts&"
import style0 from "./Deliveries.vue?vue&type=style&index=0&id=2e1d3be6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1d3be6",
  null
  
)

export default component.exports